import { render, staticRenderFns } from "./TemplateAndAttachments.vue?vue&type=template&id=d9d871d4&"
import script from "./TemplateAndAttachments.vue?vue&type=script&lang=js&"
export * from "./TemplateAndAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports